<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
import moment from 'moment'
export default
{
    mixins: [ adminTable ],

    methods:
    {
        fetch()
        {
            axios.get(process.env.API_URL + this.url).then(res => {
                this.data = res.data
                this.updateData()
            }).catch(e => {})
        },

        formatDate(date)
        {
            const d = moment(date)
            if (d.isValid())
            {
                return d.format('YYYY-MM-DD')
            }
            return null
        },

    },

    data()
    {
        return {
            url: '/v1/admin/tickets',
            tableName: 'tableTickets',
            data: [],
            emptyModel: { date:null, text:null, tixa_url: null, order: 1, ticket_prices: [], is_new_tab: false, },
            columns: [ 'id', 'type','text', 'tixa_url',  'date', 'created_at', 'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    picture: this.$t('GENERAL.IMAGE'),
                    type: this.$t('PLACE.TYPE'),
                    text: this.$t('GENERAL.TITLE'),
                    date: this.$t('GENERAL.DATE'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                    tixa_url: 'URL',
                },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name', 'created_at', 'updated_at'],
            },
        }
    },

}
</script>

<template>
    <div class="container-fluid">
        <mv-modal ref="form">
            <span slot="header">{{ $t('MENU.TICKETS') }}</span>
            <mv-ticket-form :model="model" :edit="formEdit" @save="saveForm"></mv-ticket-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.TICKETS') }}</h4>
                    </div>
                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-xs btn-success" @click="exportFile">
                            <icon name="download"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>

                    <div slot="date" slot-scope="props">
                        <div v-if="props.row.date">
                            {{ formatDate(props.row.date) }}
                        </div>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>




// WEBPACK FOOTER //
// src/pages/Tickets.vue